import React from 'react'
import ClientLogo from '../ClientLogo/ClientLogo';
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { Menu, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth';
import { useOrgContext } from '../../Context/orgContext';

const Header = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const { isOrgAdmin, setIsOrgAdmin, setIsLogedOut } = useOrgContext();
    const navigate = useNavigate();
    const open = Boolean(anchorEl);
    const auth = useAuth();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        // auth.logout();
    };

  return (
    <div className="flex justify-between bg-[#E1EDFF] pl-[68px] pr-[84px] items-center pt-6 pb-5">
        <div>
          <ClientLogo customClassName="w-[150px] h-[56px]" />
        </div>
        <div className='cursor-pointer'>
          <AccountCircleOutlinedIcon
            sx={{
              height: "30px",
              width: "30px",
              color: "#415280",
            }}
            onClick={handleClick}
          />
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            { isOrgAdmin && <MenuItem
              onClick={() => {
                navigate("/clinicManagement");
              }}
            >
              Client Management
            </MenuItem> }
            <MenuItem
              onClick={() => {
                setIsLogedOut(true);
                setIsOrgAdmin('');
                setAnchorEl(null);
                auth.logout();
                navigate("/login");
              }}
            >
              Logout
            </MenuItem>
          </Menu>
        </div>
      </div>
  )
}

export default Header
